import { FiChevronLeft } from "react-icons/fi";
import { useParams } from "react-router";
import FullScreenLoadingSpinner from "src/components/shared/loading/FullScreenLoadingSpinner";
import { IS_MOBILE_PHONE, ROUTES } from "src/constants";
import { usePatientAppointment } from "src/hooks/patients/usePatientAppointment";
import { isEmptyObject } from "../../../utils";
import PatientAppointmentCard from "./PatientAppointmentCard";

const PatientAppointment = () => {
    const params: { appointmentId: string } = useParams();
    const { appointment, isLoadingAppointment } = usePatientAppointment(
        Number(params.appointmentId),
    );

    if (!appointment || isEmptyObject(appointment) || isLoadingAppointment) {
        return <FullScreenLoadingSpinner message={["Loading appointment..."]} />;
    }
    const handleViewAppointments = () => {
        window.location.pathname = ROUTES.patientHome;
    };

    return (
        <div
            className={`container ${
                !IS_MOBILE_PHONE && "border border-top-0 rounded"
            } cy-patient-appointment`}
        >
            <div className="row my-2">
                <div className="col-10">
                    <div onClick={handleViewAppointments}>
                        <FiChevronLeft className="link" />{" "}
                        <span className="link underline">view all appointments</span>
                    </div>
                    <h3 className="extra-bold mt-4">
                        Appointment
                        <br />
                        Details
                    </h3>
                </div>
            </div>
            <div className="col mb-2">
                <div className="border-bottom">
                    <PatientAppointmentCard appointment={appointment} />
                </div>
            </div>
        </div>
    );
};
export default PatientAppointment;
